//////LIBRARY//////
import React, { useEffect, useState, Fragment, useMemo } from 'react'
import styled from 'styled-components'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { bindActionCreators } from 'redux'
import { cloneDeep, isEmpty, isUndefined, map, isEqual, isNull, find } from 'lodash'
import moment from 'moment'
//////COMPONENTS//////
import DropdownCheckbox from '../../components/DropdownCheckbox'
import Table from '../../components/Table'
import {
	campaignPriceActionCreators,
	campaignPromoActionCreators,
	pricesManagerByArticleActionCreators,
	columnsActionCreators,
	tableActionCreators,
} from '../../store/actions'
import ToggleFilters from '../../components/Ui/ToggleFilters'
import { ActionWrapperElem } from '../../theme/GlobalCss'
import ImgButton from '../../components/Ui/ImgButton'
import theme from '../../theme/theme'
import { selectIdsUser } from '../../store/selectors/user'
import PriceCampaignHandlerCreate from '../../components/PriceCampaignHandlerCreate'
import UseCheckAll from '../../hooks/UseCheckAll'
import userPrivileges from '../../constants/PrivilegesList'
import PromoCampaignHandlerCreate from '../../components/PromCampaignHandlerCreate'
import Tooltip from '../../components/Tooltip/Tooltip'
import TooltipHelp from '../../components/TooltipHelp'
import urlExport from '../../constants/UrlExport'
import ValueCheck from '../../helpers/ValueCheck'
import TableTitle from '../../components/Table/components/TableTitle'
//////ASSETS//////
import CreatePrice from '../../assets/icones/global/createPrice.svg'
import ErrorSign from '../../assets/icones/global/warning-red.svg'
import CreatePromo from '../../assets/icones/global/megaphone-white.svg'

//////STYLED//////
const UsersManagerWrapper = styled.div`
	position: relative;
`
const ErrorSignImg = styled.img`
	max-height: 32px;
	margin-left: 5px;
`
//////STYLED//////

const PricesManagerByArticle = () => {
	const {
		user,
		translations,
		pricesManagerByArticle,
		pricesManagerByArticleFilters,
		campaign,
		successCreateCampaign,
		userKioskPerimeter,
		campaignErrors,
		successCreateCampaignPromo,
		campaignPromoErrors,
		campaignPromo,
		isSearchfieldUpdated,
		currentColumn,
		currentDir,
	} = useSelector(
		(state) => ({
			translations: state.languages.translations,
			campaign: state.campaignPrice.campaign,
			campaignPromo: state.campaignPromo.campaign,
			pricesManagerByArticle: state.pricesManagerByArticle,
			pricesManagerByArticleFilters: state.pricesManagerByArticle.header,
			user: state.user,
			userIds: selectIdsUser(state),
			successCreateCampaign: state.campaignPrice.isSuccess || false,
			campaignErrors: state.campaignPrice.error?.data || [],
			successCreateCampaignPromo: state.campaignPromo.isSuccess || false,
			campaignPromoErrors: state.campaignPromo.error?.data || [],
			userKioskPerimeter: state.user.identity.kioskSelected,
			isSearchfieldUpdated: state.columns.isSearchfieldUpdated,
			currentColumn: state.columns.currentColumn,
			currentDir: state.columns.currentDir,
		}),
		shallowEqual
	)

	const actionsPricesManagerByArticle = bindActionCreators(pricesManagerByArticleActionCreators, useDispatch())
	const campaignActions = bindActionCreators(campaignPriceActionCreators, useDispatch())
	const campaignPromoActions = bindActionCreators(campaignPromoActionCreators, useDispatch())
	const actionsColumns = bindActionCreators(columnsActionCreators, useDispatch())
	const actionsTable = bindActionCreators(tableActionCreators, useDispatch())

	// Filters
	const [prevFilter, setPrevFilter] = useState({})
	// Custom method to submit on radio change
	const handleSubmitRadioClose = (newFilters) => {
		// We want to use changed filters, not waiting for useEffect (sort of force method)
		const filt = {
			withFilters: true,
			...newFilters,
			userKioskScope: {
				kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
			},
		}
		actionsPricesManagerByArticle.getPriceArticles(filt, { paging, action: 'byItem' })
	}
	const [filters, setFilters, handleCheckElements] = UseCheckAll(prevFilter, handleSubmitRadioClose)

	// Search bar
	const [searchValue, setSearchValue] = useState('')

	// Data
	const [inputData, setInputData] = useState([])
	const [paging, setPaging] = useState({
		page: '0',
		size: '250',
		action: 'byItem',
		sort: 'itemDistributor.item.family.label',
		nameDir: 'asc',
		sort_2: 'itemDistributor.item.brand.label',
		nameDir_2: 'asc',
		sort_3: 'itemDistributor.item.label',
		nameDir_3: 'asc',
	})

	// Modals
	const [showModalEditCampaign, setShowModalEditCampaign] = useState(false)
	const [showModalEditCampaignPromo, setShowModalEditCampaignPromo] = useState(false)

	const [currentPerimeterKiosks, setCurrentPerimeterKiosks] = useState([])

	// Columns
	const [columns, setColumns] = useState([])

	/////////////////////////////// HANDLER //////////////////////////////////////

	const handlePagingPriceManagerArticle = (paging) => {
		let sortMap = {}
		if (!isUndefined(currentColumn.value)) {
			sortMap = {
				sort: currentColumn.value,
				nameDir: currentDir.value,
				action: 'byItem',
			}
		} else {
			sortMap = {
				sort: 'itemDistributor.item.family.label',
				nameDir: 'asc',
				sort_2: 'itemDistributor.item.brand.label',
				nameDir_2: 'asc',
				sort_3: 'itemDistributor.item.label',
				nameDir_3: 'asc',
				action: 'byItem',
			}
		}

		const pg = { ...paging, ...sortMap }
		setPaging(pg)
		actionsPricesManagerByArticle.getPriceArticles(handleFilterSend(), {
			...pg,
			action: 'byItem',
		})
	}

	const handlePriceOrPromo = (data, target) => {
		switch (target) {
			case 'price':
				handleModalEditCampaign(data)
				break
			case 'promo':
				handleModalPromo(data)
				break

			default:
				break
		}
	}

	const handleModalPromo = (dataRow) => {
		if (!dataRow.length) return // guard do nothing if no line was selected
		const checkItemFormat = {
			selectedItems: map(dataRow, (elem) => ({
				idItem: elem.id,
				idKiosk: null,
			})),
			kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
			dateStart: moment().add(1, 'hours').toDate(),
			dateEnd: moment().add(1, 'weeks').toDate(),
			withTTC: filters.pricesTTC,
			idDistributor:
				find(filters.filtersSelection.distributors.filterElements, { active: true }).id ||
				filters.filtersSelection.distributors.filterElements[0].id,
			currency: dataRow[0].currency.symbol,
		}
		if (!showModalEditCampaignPromo && !isNull(dataRow)) {
			campaignPromoActions.checkCampaignPromo(checkItemFormat, 'byArticle')
			//setShowModalEditCampaignPromo(true)
		} else {
			handleSubmit(true)
			setShowModalEditCampaignPromo(false)
		}
	}

	const handleModalEditCampaign = (dataRow) => {
		if (!dataRow.length) return // guard do nothing if no line was selected
		const checkItemFormat = {
			selectedItems: map(dataRow, (elem) => ({
				idItem: elem.id,
				idKiosk: null,
			})),
			kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
			dateStart: new Date(),
			withTTC: filters.pricesTTC,
			idDistributor:
				find(filters.filtersSelection.distributors.filterElements, { active: true }).id ||
				filters.filtersSelection.distributors.filterElements[0].id,
			currency: dataRow[0].currency.symbol,
		}

		if (!showModalEditCampaign && !isNull(dataRow)) {
			campaignActions.checkCampaign(checkItemFormat, 'byArticle')
		} else {
			handleSubmit(true)
			setShowModalEditCampaign(false)
		}
	}

	const handleWithTTC = () => {
		let filtersCP = cloneDeep(filters)
		filtersCP.pricesTTC = !filtersCP.pricesTTC

		setFilters(filtersCP)

		const str_filters = handleFilterSend()
		// // Even if we set our hook, in HandleFilterSend,
		// // TTC value is not actualised,
		// // So we reset value here...
		str_filters.pricesTTC = !str_filters.pricesTTC
		str_filters.searchFieldByItem = searchValue

		actionsPricesManagerByArticle.getPriceArticles(str_filters, {
			...paging,
			action: 'byItem',
		})
	}

	const handleSearchEnter = (e, val) => {
		if (e.keyCode !== 13) return
		setSearchValue(val)
		actionsColumns.setIsSearchfieldUpdated(true)
	}

	const handleClickSearch = (refInput) => {
		setSearchValue(refInput.current.value)
		actionsColumns.setIsSearchfieldUpdated(true)
	}

	const handleSubmit = (force = false) => {
		if (force) {
			actionsPricesManagerByArticle.getPriceArticles(handleFilterSend(), {
				...paging,
				action: 'byItem',
			})
			return
		}

		if (isEqual(filters, prevFilter)) return // guard to call if no change

		setPrevFilter(filters)

		// Force reset paging at zero, in case when filters are preventing any pagination with current size
		let pg = cloneDeep(paging)
		if (isUndefined(pg)) {
			pg = {
				page: '0',
				size: '250',
				action: 'byItem',
				sort: 'itemDistributor.item.family.label',
				nameDir: 'asc',
				sort_2: 'itemDistributor.item.brand.label',
				nameDir_2: 'asc',
				sort_3: 'itemDistributor.item.label',
				nameDir_3: 'asc',
			}
		} else {
			pg.page = '0'
		}
		setPaging(pg)

		actionsPricesManagerByArticle.getPriceArticles(handleFilterSend(), {
			...pg,
			action: 'byItem',
		})
	}

	const handleFilterSend = () => {
		const filtersIn = cloneDeep(filters)
		let searchFieldUpdated = {}
		let filtersOut = {}

		if (isSearchfieldUpdated) {
			searchFieldUpdated = {
				searchFieldUpdated: true,
			}
		} else {
			searchFieldUpdated = {
				searchFieldUpdated: false,
			}
		}
		filtersOut = { ...searchFieldUpdated, ...filtersIn }
		return {
			withFilters: true,
			...filtersOut,
			userKioskScope: {
				kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
			},
		}
	}

	/////////////////////////////// CONFIG //////////////////////////////////////

	useEffect(() => {
		setColumns([
			{
				columnReferential: 'articlePrice_family',
				dataHook: 'itemFamily.translationKey',
				toTranslate: true,
				toMapObject: true,
				headerName: translations['page__pricesManagement__pricesByItem__admin__pricesTable_tableHeader_familly'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'itemDistributor.item.family.label',
			},
			{
				columnReferential: 'articlePrice_brand',
				dataHook: 'itemBrand.label',
				toMapObject: true,
				headerName: translations['page__pricesManagement__pricesByItem__admin__pricesTable_tableHeader_brand'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'itemDistributor.item.brand.label',
			},
			{
				columnReferential: 'articlePrice_type',
				dataHook: 'gasType',
				headerName: translations['page__pricesManagement__pricesByItem__admin__pricesTable_tableHeader_type'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'itemDistributor.item.itemSpecificity.label',
			},
			{
				columnReferential: 'articlePrice_itemCode',
				dataHook: 'codeItem',
				headerName: translations['page__pricesManagement__pricesByItem__admin__pricesTable_tableHeader_itemCode'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'itemDistributor.item.label',
			},
			{
				columnReferential: 'articlePrice_item',
				dataHook: 'labelToDisplay',
				headerName: translations['page__pricesManagement__pricesByItem__admin__pricesTable_tableHeader_itemLabel'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'itemDistributor.labelToDisplay',
			},
			{
				columnReferential: 'articlePrice_salePrice',
				dataHook: 'standardItemPriceRange',
				headerName: translations['page__pricesManagement__pricesByItem__admin__pricesTable_tableHeader_standardPrice'],
				toMapObject: true,
				sortable: true,
				component: (props) => ValueCheck.ValueCheck(props.row.standardItemPriceRange, '-'),
				isAuthorize: true,
			},
			{
				columnReferential: 'articlePrice_consignmentPrice',
				dataHook: 'depositPriceItemRange',
				headerName: translations['page__pricesManagement__pricesByItem__admin__pricesTable_tableHeader_depositPrice'],
				toMapObject: true,
				sortable: true,
				component: (props) => ValueCheck.ValueCheck(props.row.depositPriceItemRange, '-'),
				isAuthorize: true,
			},
		])
	}, [translations])

	// Used for columns displaying (redux stored)
	const tableReferential = {
		idPageTable: 4,
		labelPageTable: 'articlePrice',
	}

	/////////////////////////////// USE EFFECT //////////////////////////////////////

	// Moved content inside campaign modal to avoid loops
	/*useEffect(() => {
		if (isEmpty(campaign)) return // guard to set row on reset campaign
		setRow({
			kiosks: campaign.Kiosks,
			priceCampaignLines: campaign.Items,
			currency: campaign.currency,
			label: '',
			dateStart: null,
			idDistributor: find(filters.filtersSelection.distributors?.filterElements, { active: true }).id || filters.filtersSelection.distributors?.filterElements[0].id,
		})
	}, [campaign])*/

	// Moved content inside promo modal to avoid loops
	/*
	useEffect(() => {

		if (isEmpty(campaignPromo)) return // guard to set row on reset campaignPromo
		setRow({
			kiosks: campaignPromo.Kiosks,
			priceCampaignLines: campaignPromo.Items,
			currency: campaignPromo.currency,
			label: '',
			dateStart: null,
			idDistributor: find(filters.filtersSelection.distributors.filterElements, { active: true }).id || filters.filtersSelection.distributors.filterElements[0].id,
		})
	}, [campaignPromo])*/

	useEffect(() => {
		return function cleanUp() {
			actionsTable.resetPaggingConfig()
		}
	}, [])

	useEffect(() => {
		if (isUndefined(searchValue)) return
		const filtersCP = cloneDeep(filters)
		filtersCP.searchFieldByItem = searchValue
		setFilters(filtersCP)
	}, [searchValue])

	useEffect(() => {
		if (filters.searchFieldByItem !== searchValue) return
		handleSubmit()
	}, [filters.searchFieldByItem])

	// Config
	const [configTableTitle, setConfigTableTitle] = useState({
		actions: {
			searchBarComponent: {
				handleSearchEnter: handleSearchEnter,
				handleClickSearch: handleClickSearch,
				placeholder: translations['common__text__fastFilter_search'],
				handleReset: (refInput) => {
					refInput.current.value = ''
					setSearchValue('')
				},
			},
			toggleLists: [
				() => (
					<TooltipHelp content={'tooltipHelp__admin__modal__body__table__filter__vatSwitch'} childrenPos={2}>
						<ToggleFilters
							defaultChecked
							onChangeHandler={handleWithTTC}
							name="withTTC"
							labelPrev={translations['page__global__admin__header_priceSwitch_priceHT']}
							labelNext={translations['page__global__admin__header_priceSwitch_priceTTC']}
						/>
					</TooltipHelp>
				),
			],
			rest: [],
		},
		paging: {
			fnSendTo: (paging) => handlePagingPriceManagerArticle(paging),
		},
	})

	const [configTable, setConfigTable] = useState({
		getSelected: (getSelectedData) => {
			// button to layout for get data selected ( getSelectedData is actions.edit.getDataSelected function )
			return (
				<>
					{!isUndefined(find(user.identity.rolePrivileges.privileges, (o) => o.label === userPrivileges.action[2])) && (
						<ActionWrapperElem>
							<Tooltip
								translationsKey={'tooltip__admin__priceManagement__createPriceCampaign'}
								tooltipId={'kioskPriceScheduledPriceCampaign'}
							>
								<ImgButton
									as={'div'}
									action={() => getSelectedData('price')}
									img={CreatePrice}
									color={theme.colors.primary}
									hover={theme.colors.hoverPrimary}
								/>
							</Tooltip>
						</ActionWrapperElem>
					)}
					{!isUndefined(find(user.identity.rolePrivileges.privileges, (o) => o.label === userPrivileges.action[3])) ? (
						<ActionWrapperElem>
							<Tooltip
								translationsKey={'tooltip__admin__priceManagement__createPromoCampaign'}
								tooltipId={'kioskPriceScheduledPromoCampaign'}
							>
								<ImgButton
									as={'div'}
									img={CreatePromo}
									action={() => getSelectedData('promo')}
									color={theme.colors.primary}
									hover={theme.colors.hoverPrimary}
								/>
							</Tooltip>
						</ActionWrapperElem>
					) : null}
				</>
			)
		},
		actions: {
			edit:
				!isUndefined(find(user.identity.rolePrivileges.privileges, (o) => o.label === userPrivileges.action[2])) ||
				!isUndefined(find(user.identity.rolePrivileges.privileges, (o) => o.label === userPrivileges.action[3]))
					? {
							getDataSelected: (dataCP, target) => {
								// action to execute when getSelected data is click. dataCp is array of object => selected data
								handlePriceOrPromo(dataCP, target)
							},
					  }
					: null,
			rest: [],
		},
	})

	useEffect(() => {
		const cfg = cloneDeep(configTableTitle)
		cfg.paging = {
			totalElements: pricesManagerByArticle.paging.totalElements,
			totalPages: pricesManagerByArticle.paging.totalPages,
			fnSendTo: (paging) => handlePagingPriceManagerArticle(paging),
		}
		setConfigTableTitle(cfg)
		setInputData(pricesManagerByArticle.items)
	}, [pricesManagerByArticle.items])

	useEffect(() => {
		setFilters(pricesManagerByArticleFilters)
		setPrevFilter(pricesManagerByArticleFilters)
	}, [translations, pricesManagerByArticleFilters])

	useEffect(() => {
		let cfg = cloneDeep(configTableTitle)
		cfg.name = translations['page__pricesManagement__pricesByItem_title']
		cfg.actions.searchBarComponent = {
			handleSearchEnter: handleSearchEnter,
			handleClickSearch: handleClickSearch,
			placeholder: translations['common__text__fastFilter_search'],
			handleReset: (refInput) => {
				refInput.current.value = ''
				setSearchValue('')
			},
		}
		cfg.paging = {
			totalElements: pricesManagerByArticle.paging.totalElements,
			totalPages: pricesManagerByArticle.paging.totalPages,
			fnSendTo: (paging) => handlePagingPriceManagerArticle(paging),
		}
		cfg.actions.rest = [
			() => (
				<DropdownCheckbox
					title={translations['page__pricesManagement__pricesByItem__admin__header__filter_distributor']}
					data={filters.filtersSelection?.distributors.filterElements || []}
					translations={translations}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'distributors'}
					radio
				/>
			),
			() => (
				<>
					<DropdownCheckbox
						title={translations['page__pricesManagement__pricesByItem__admin__header__filter_currency']}
						data={filters.filtersSelection?.currencies.filterElements || []}
						translations={translations}
						paperTopPosition={'40'}
						dropColor={'blueColor'}
						selectActionsHandler={handleCheckElements}
						submitOnClose={handleSubmit}
						target={'currencies'}
						radio
					/>
					{filters.currencies?.length > 1 && <ErrorSignImg src={ErrorSign} />}
				</>
			),
			() => (
				<DropdownCheckbox
					title={translations['page__pricesManagement__pricesByItem__admin__header__filter_familly']}
					data={filters.filtersSelection?.famillies.filterElements || []}
					translations={translations}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'famillies'}
					toTranslate
				/>
			),
			() => (
				<DropdownCheckbox
					title={translations['page__pricesManagement__pricesByItem__admin__header__filter_brand']}
					data={filters.filtersSelection?.brands.filterElements || []}
					translations={translations}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'brands'}
				/>
			),
		]
		cfg.actions.toggleLists = [
			() => (
				<TooltipHelp content={'tooltipHelp__admin__modal__body__table__filter__vatSwitch'} childrenPos={2}>
					<ToggleFilters
						checked={filters.pricesTTC}
						onChangeHandler={handleWithTTC}
						name="withTTC"
						size={'large'}
						labelPrev={translations['page__global__admin__header_priceSwitch_priceHT']}
						labelNext={translations['page__global__admin__header_priceSwitch_priceTTC']}
					/>
				</TooltipHelp>
			),
		]

		setConfigTableTitle(cfg)
	}, [translations, filters, prevFilter])

	useEffect(() => {
		const cfpCp = cloneDeep(configTable)
		cfpCp.export = {
			privilege: userPrivileges.export[2],
			url: urlExport[7],
			bd: {
				filtersSelection: filters.filtersSelection,
				pricesTTC: filters.pricesTTC,
				searchFieldByItem: searchValue,
				withFilters: true,
				userKioskScope: {
					kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
				},
			},
		}
		cfpCp.actions.edit = !isUndefined(find(user.identity.rolePrivileges.privileges, (o) => o.label === userPrivileges.action[2]))
			? {
					getDataSelected: (dataCP, target) => {
						// action to execute when getSelected data is click. dataCp is array of object => selected data
						handlePriceOrPromo(dataCP, target)
					},
			  }
			: null
		setConfigTable(cfpCp)
	}, [translations, filters, prevFilter])

	useEffect(() => {
		const userCp = cloneDeep(user)
		const isPriceTTC = userCp.identity.isPricesTTC
		if (isUndefined(user) || isEmpty(translations)) return
		if (isEmpty(filters)) {
			const filtersCp = {
				withFilters: false,
				searchFieldByItem: null,
				pricesTTC: isPriceTTC,

				userKioskScope: {
					kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
				},
				searchFieldUpdated: false,
			}
			actionsPricesManagerByArticle.getPriceArticles(filtersCp)
			actionsColumns.setColumns([])
			setFilters(filtersCp)
		}
	}, [filters, user, translations])

	// If user is changing his perimeter, we need to make a back call
	useEffect(() => {
		const pagingCP = cloneDeep(paging)
		const queryParams = {
			...pagingCP,
			...{ action: 'byItem' },
		}
		if (!isEqual(userKioskPerimeter, currentPerimeterKiosks) && !isEmpty(currentPerimeterKiosks))
			actionsPricesManagerByArticle.getPriceArticles(
				{
					withFilters: false,
					pricesTTC: user.identity.isPricesTTC,
					userKioskScope: {
						kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
					},
				},
				queryParams
			)
		setCurrentPerimeterKiosks(userKioskPerimeter)
	}, [userKioskPerimeter])

	//
	useEffect(() => {
		// Waiting that campaign is not empty before opening modal ?
		if (!isEqual(campaign, {}) && !showModalEditCampaign) setShowModalEditCampaign(true)
	}, [campaign])

	useEffect(() => {
		// Waiting that promo is not empty before opening modal ?
		if (!isEqual(campaignPromo, {}) && !showModalEditCampaignPromo) setShowModalEditCampaignPromo(true)
	}, [campaignPromo])

	///////////////////////////////// RENDER ///////////////////////////////////////

	const TableRender = useMemo(() => {
		return (
			<Table
				inputColumns={columns}
				inputData={pricesManagerByArticle.items}
				inputConfig={configTable}
				currentPaging={paging}
				isLoading={pricesManagerByArticle.isLoading}
				tableReferential={tableReferential}
				actionSort={actionsPricesManagerByArticle.getPriceArticles}
			/>
		)
	}, [pricesManagerByArticle, columns, configTable, translations, paging])

	return (
		<Fragment>
			{!isUndefined(filters.pricesTTC) /*row.kiosks?.length &&*/ && (
				<PriceCampaignHandlerCreate
					closeModalHandler={() => {
						setShowModalEditCampaign(false)
						handleSubmit(true)
						campaignActions.resetCampaignItems()
					}}
					showModal={showModalEditCampaign}
					//data={cloneDeep(row)}
					//setRow={setRow}
					widthTaxes={filters.pricesTTC}
					campaignErrors={campaignErrors}
					successCreateCampaign={successCreateCampaign}
					target={'byArticle'}
					filters={filters}
				/>
			)}
			{!isUndefined(filters.pricesTTC) /*row.kiosks?.length &&*/ && (
				<PromoCampaignHandlerCreate
					closeModalHandler={() => {
						setShowModalEditCampaignPromo(false)
						handleSubmit(true)
						campaignPromoActions.resetCampaignPromoItems()
					}}
					showModal={showModalEditCampaignPromo}
					//data={cloneDeep(row)}
					//setRow={setRow}
					widthTaxes={filters.pricesTTC}
					campaignErrors={campaignPromoErrors}
					successCreateCampaign={successCreateCampaignPromo}
					target={'byArticle'}
					filters={filters}
				/>
			)}
			<UsersManagerWrapper>
				{!isUndefined(translations) && !isUndefined(configTableTitle) && (
					<TableTitle inputConfig={configTableTitle} inputColumns={columns} tableReferential={tableReferential} />
				)}
				{!isUndefined(translations) && !isUndefined(configTable) && TableRender}
			</UsersManagerWrapper>
		</Fragment>
	)
}

PricesManagerByArticle.propTypes = {}

PricesManagerByArticle.defaultPropTypes = {}

export default PricesManagerByArticle
